<template>
	<div class="cart-summary" v-if="cart">
		<div class="products-table">
			<div v-for="(product, i) in products" :key="i" class="product-item">
				<div class="product-detail flex-grow-1">
					<img v-if="product.variant && product.variant.image" :src="product.variant.image.urlThumb" alt="" class="img-fluid" />
					<img v-else-if="product.product.image" :src="product.product.image.urlThumb" alt="" />
					<div class="ml-2">
						<h3>{{ product.product.name }}</h3>
						<p v-if="product.variant">{{ product.variant.name }}</p>
					</div>
				</div>
				<div class="d-flex align-items-center justify-content-between">
					<div v-if="editable">
						<div class="quantity" style="width:120px" :class="{ error: product.stockInsufficient }">
							<div class="btn btn-secondary btn-qty" @click="qty('subtract', i)">-</div>
							{{ product.qty }}
							<div class="btn btn-secondary btn-qty" @click="qty('add', i)">+</div>
						</div>
						<div v-if="product.stockInsufficient" class="text-danger text-center">Stock insuficiente</div>
					</div>
					<div class="price" style="width:90px">
						<small>U$S</small> {{ product.priceSubtotal.toFixed(2) }}
					</div>
				</div>
			</div>
		</div>

		<hr />

		<div class="d-flex justify-content-end">
			<table class="table prices-table table-borderless">
				<tr>
					<td>Subtotal</td>
					<td>U$S {{ cart.priceSubtotal.toFixed(2) }}</td>
				</tr>
				<tr>
					<td>Impuestos</td>
					<td>U$S {{ cart.priceTaxes.toFixed(2) }}</td>
				</tr>
				<tr>
					<td><strong>TOTAL</strong></td>
					<td>
						<strong>U$S {{ cart.priceTotal.toFixed(2) }}</strong>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
import ecommerceMixins from './mixins'
export default {
	name: 'CarProductsTable',
	props: ['cart', 'editable'],
	mixins: [ecommerceMixins],
	computed: {
		products: function() {
			return this.cart.products.map((p) => {
				return {
					...p,
					priceSubtotal: p.priceSubtotal,
				}
			})
		},
	},
	async beforeMount() {
		// cargo los productos desde el sistema para controlar cambios de precios, y stocks
		await this.updateCartProducts()
	},
	methods: {
		qty(action, index) {
			this.cartQuantity(action, index)
		},
	},
}
</script>

<style scoped>
.products-table .product-item {
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid #dee2e6;
	min-height: 72px;
}
.products-table > div,
.products-table > div:last-child {
	border: none;
}

.product-detail {
	display: flex;
	align-items: center;
	padding: 0px;
}
.product-detail h3 {
	font-size: 14px;
    font-weight: 600;
    color: #333;
}
.product-detail p {
	margin: 0px;
	font-size: 13px;
    font-weight: 500;
    color: #333;
}
.product-detail img {
	max-width: 52px;
}
.product-item .price {
	text-align: right;
	font-size: 14px;
    font-weight: 600;
    color: #333;
}

.prices-table {
}
.prices-table tr td {
	padding: 0.5rem;
}
.prices-table tr td:last-child {
	text-align: right;
}

.quantity {
	display: flex;
	align-items: center;
	justify-content: center;
}
.btn-qty {
	width: 36px;
	height: 36px;
	padding: 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0px 10px;
	border: none;
	background-color: #f3f3f3;
}

/*
.cart-section {
	opacity: 0.6;
}
.cart-section.active {
	opacity: 1;
}

div ::v-deep .formulate-input .formulate-input-element {
	max-width: 100%;
	margin-bottom: 0.1em;
}

@media (max-width: 400px) {
	.product-detail img {
		display: none;
	}
}
*/
@media (min-width: 996px) {
	.products-table .product-item {
		flex-direction: row;
	}
	.prices-table {
		max-width: 300px;
	}
}
</style>
